import { SliderUnstyled } from '@mui/base'
import styles from './Slider.module.scss'
import React from 'react'

type Props = {
  min: number
  max: number
  value?: number | number[]
  valueSuffix?: string
  suffixNewLine?: boolean
  step?: number
  onChange?: (value: number | number[]) => void
  onChangeCommitted?: (value: number | number[]) => void
}

interface SliderValueLabelProps {
  children: React.ReactElement;
  suffix?: string;
}

const Slider = (props: Props) => {
  const SliderValueLabel = ({ children }: SliderValueLabelProps) => {
    return (
      <div className={styles.sliderValue}>
        {children}
        <br />
        <span>{props.valueSuffix}</span>
      </div>
    )
  }

  const onChangeHandler = (event: Event | React.SyntheticEvent<Element, Event>, value: number | number[]): void => {
    props.onChange?.(value)
  }

  const onChangeCommitedHandler = (event: Event | React.SyntheticEvent<Element, Event>, value: number | number[]): void => {
    props.onChangeCommitted?.(value)
  }

  return (
    <div className={styles.component}>
      <SliderUnstyled
        min={props.min}
        max={props.max}
        step={props.step}
        value={props.value}
        slots={{ valueLabel: SliderValueLabel }}
        onChange={onChangeHandler}
        onChangeCommitted={onChangeCommitedHandler}
        slotProps={{
          root: {
            className: styles.root
          },
          rail: {
            className: styles.rail
          },
          track: {
            className: styles.track
          },
          mark: {
            className: styles.mark
          },
          markLabel: {
            className: styles.markLabel
          },
          thumb: {
            className: styles.thumb
          }
        }}
      />
    </div>
  )
}

export default Slider